import {Component, signal} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';

@Component({
  selector: 'app-product-stock-limit-modal',
  templateUrl: './product-stock-limit-modal.component.html',
  styleUrls: ['./product-stock-limit-modal.component.scss'],
  imports: [ModalContainerComponent]
})
export class ProductStockLimitModalComponent {

  public readonly maxQty = signal<number | null>(null);

  public readonly unit = signal<string | null>(null);

}
